import { render, staticRenderFns } from "./AccountMyAccount.vue?vue&type=template&id=6f845022&scoped=true&"
import script from "./AccountMyAccount.vue?vue&type=script&lang=js&"
export * from "./AccountMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f845022",
  null
  
)

export default component.exports